import { ref } from 'vue';
import { useAccounts } from './useAccounts';
import { useAccountStore } from '@apparatix/stores/useAccountStore';

export const useAccountDetails = () => {
  const store = useAccountStore();
  const { updateAccount } = useAccounts();

  const saveTimeoutId = ref<number>();

  const saveFieldChange = async (fieldPath: string) => {
    clearTimeout(saveTimeoutId.value);

    saveTimeoutId.value = window.setTimeout(() => sendAccountUpdate(fieldPath), 1000);
  };

  const sendAccountUpdate = async (formUpdates) => {
    formUpdates.id = store.accountDetails.id;

    await updateAccount({ data: { accounts: [formUpdates]}});
  };

  return {
    saveFieldChange,
    sendAccountUpdate,
  };
};
